import React from "react";
import { AskSourceOne } from "../../../index";

export default function SourceOneAssistant() {
   return (
      <div>
         <AskSourceOne homepage={true} />
      </div>
   );
}
